var _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _circle, _circle2, _circle3, _g3, _path8, _path9, _path10, _path11, _g4, _g5, _path12, _g6, _path13, _g7, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartyingFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_713_9065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 29C24.6684 29 29 23.1797 29 16C29 8.8203 24.6684 3 16 3C7.33161 3 3 8.8203 3 16C3 23.1797 7.33161 29 16 29Z",
    fill: "url(#paint0_radial_713_9065)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29C24.6684 29 29 23.1797 29 16C29 8.8203 24.6684 3 16 3C7.33161 3 3 8.8203 3 16C3 23.1797 7.33161 29 16 29Z",
    fill: "url(#paint1_radial_713_9065)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3H17L3 16V5C3 3.89543 3.89543 3 5 3Z",
    fill: "#BB1D80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3H17L3 16V5C3 3.89543 3.89543 3 5 3Z",
    fill: "url(#paint2_linear_713_9065)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41421 3L3 8.41421V5.58579L5.58579 3H8.41421Z",
    fill: "#5092FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 3L3 13.4142V10.5858L10.5858 3H13.4142Z",
    fill: "#5092FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_713_9065)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.6879,
    cy: 9.95155,
    r: 1.10149,
    transform: "rotate(28.149 23.6879 9.95155)",
    fill: "#E37847",
    fillOpacity: 0.75
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 8.75C26.2885 8.75 27.75 7.5 27.75 5.75",
    stroke: "url(#paint3_radial_713_9065)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 27.75C8.28849 27.75 9.75 26.5 9.75 24.75",
    stroke: "url(#paint4_radial_713_9065)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 28,
    r: 1,
    fill: "url(#paint5_radial_713_9065)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 20,
    r: 1,
    fill: "url(#paint6_radial_713_9065)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 3,
    r: 1,
    fill: "url(#paint7_radial_713_9065)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_713_9065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.9973H24.4288C25.8954 19.9973 27.0933 18.8257 27.126 17.3596L27.1433 16.5843C27.1675 15.4965 26.2924 14.6016 25.2043 14.6016V14.6016C24.3474 14.6016 23.6527 15.2962 23.6527 16.1531V17.0258C23.6527 17.527 24.059 17.9332 24.5601 17.9332V17.9332C25.0612 17.9332 25.4675 17.527 25.4675 17.0258V16.7418",
    stroke: "#BB582B",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 19.8308H26.5027C28.1498 19.8308 29.498 18.5202 29.5444 16.8737L29.5526 16.5848C29.5965 15.0295 28.3477 13.7449 26.7917 13.7449H26.7294C25.5435 13.7449 24.5821 14.7063 24.5821 15.8922V16.2062C24.5821 16.9222 25.1626 17.5027 25.8786 17.5027V17.5027C26.5947 17.5027 27.1751 16.9222 27.1751 16.2062V16.1589",
    stroke: "#00A6ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 19.8308H26.5027C28.1498 19.8308 29.498 18.5202 29.5444 16.8737L29.5526 16.5848C29.5965 15.0295 28.3477 13.7449 26.7917 13.7449H26.7294C25.5435 13.7449 24.5821 14.7063 24.5821 15.8922V16.2062C24.5821 16.9222 25.1626 17.5027 25.8786 17.5027V17.5027C26.5947 17.5027 27.1751 16.9222 27.1751 16.2062V16.1589",
    stroke: "url(#paint8_radial_713_9065)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 19.8308H26.5027C28.1498 19.8308 29.498 18.5202 29.5444 16.8737L29.5526 16.5848C29.5965 15.0295 28.3477 13.7449 26.7917 13.7449H26.7294C25.5435 13.7449 24.5821 14.7063 24.5821 15.8922V16.2062C24.5821 16.9222 25.1626 17.5027 25.8786 17.5027V17.5027C26.5947 17.5027 27.1751 16.9222 27.1751 16.2062V16.1589",
    stroke: "url(#paint9_radial_713_9065)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 19.8308H26.5027C28.1498 19.8308 29.498 18.5202 29.5444 16.8737L29.5526 16.5848C29.5965 15.0295 28.3477 13.7449 26.7917 13.7449H26.7294C25.5435 13.7449 24.5821 14.7063 24.5821 15.8922V16.2062C24.5821 16.9222 25.1626 17.5027 25.8786 17.5027V17.5027C26.5947 17.5027 27.1751 16.9222 27.1751 16.2062V16.1589",
    stroke: "url(#paint10_radial_713_9065)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_713_9065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3672 19.6902H26.2214C27.8686 19.6902 29.2167 18.3796 29.2632 16.7331L29.2714 16.4442C29.3153 14.8889 28.0664 13.6042 26.5105 13.6042H26.4482C25.2623 13.6042 24.3009 14.5656 24.3009 15.7516V16.0656C24.3009 16.7816 24.8813 17.3621 25.5974 17.3621V17.3621C26.3134 17.3621 26.8939 16.7816 26.8939 16.0656V16.0183",
    stroke: "#A0D9FF",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_713_9065)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.3359,
    cy: 16,
    r: 0.382812,
    fill: "#C7E8FF"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.24C17.4477 16.24 17 16.6877 17 17.24C17 17.7923 17.4477 18.24 18 18.24C18.1636 18.24 18.2955 18.3718 18.2955 18.5355C18.2955 18.6991 18.1636 18.8309 18 18.8309C17.4477 18.8309 17 19.2786 17 19.8309C17 19.8309 17 19.8309 17 19.8309C17 20.3832 17.4477 20.831 18 20.831C18.1636 20.831 18.2955 20.9628 18.2955 21.1264C18.2955 21.2901 18.1636 21.4219 18 21.4219C17.4477 21.4219 17 21.8696 17 22.4219C17 22.9742 17.4477 23.4219 18 23.4219C19.2682 23.4219 20.2955 22.3946 20.2955 21.1264C20.2955 20.6457 20.1479 20.1996 19.8955 19.8309C20.1479 19.4623 20.2955 19.0162 20.2955 18.5355C20.2955 17.2673 19.2682 16.24 18 16.24Z",
    fill: "url(#paint11_radial_713_9065)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_713_9065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8945 12.6768C18.8945 12.6768 19.4449 11.1837 20.8454 11.4504C22.6605 11.796 22.7964 13.7499 22.7964 13.7499",
    stroke: "url(#paint12_radial_713_9065)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6484 13.0591C18.8633 12.5122 19.4141 11.4185 20.978 11.4185C22.4844 11.4185 23.083 12.5122 23.3125 13.0591",
    stroke: "url(#paint13_radial_713_9065)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_713_9065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51172 12.6719C9.51172 12.6719 10.0621 11.1788 11.4626 11.4455C13.2777 11.7911 13.4136 13.745 13.4136 13.745",
    stroke: "url(#paint14_radial_713_9065)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4707 13.0591C9.68559 12.5122 10.2363 11.4185 11.8003 11.4185C13.3066 11.4185 13.9052 12.5122 14.1348 13.0591",
    stroke: "url(#paint15_radial_713_9065)",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_713_9065",
    x: 3,
    y: 1,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_713_9065"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_713_9065",
    x: 20.5859,
    y: 6.84985,
    width: 6.20312,
    height: 6.20337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_713_9065"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_713_9065",
    x: 17.75,
    y: 12.8516,
    width: 11.1445,
    height: 8.89575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_713_9065"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_713_9065",
    x: 17.1172,
    y: 12.3542,
    width: 13.4062,
    height: 8.58594,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_713_9065"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_713_9065",
    x: 25.9531,
    y: 14.6172,
    width: 2.76562,
    height: 2.76562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_713_9065"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_713_9065",
    x: 17.6445,
    y: 10.168,
    width: 6.40234,
    height: 4.83203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_713_9065"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_713_9065",
    x: 8.26172,
    y: 10.1631,
    width: 6.40234,
    height: 4.83203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_713_9065"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.8232 9.50052) rotate(132.839) scale(34.8273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.001 12.7508) rotate(90) scale(16.6092)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.823911,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF63C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_713_9065",
    x1: 3,
    y1: 18.9453,
    x2: 16,
    y2: 4.13281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5092FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#5092FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8906 8.91406) rotate(-129.912) scale(3.23894 13.7191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FF42B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE336E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.89062 27.9141) rotate(-129.912) scale(3.23894 13.7191)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FF42B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE336E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.5 27.5) rotate(135) scale(1.41421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E80FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.5 19.5) rotate(135) scale(1.41421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E80FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.5 2.5) rotate(135) scale(1.41421)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45C9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E80FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4382 15.3202) rotate(9.65183) scale(4.65971 7.89053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#1B6AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A80F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1882 16.0546) rotate(27.8973) scale(1.20221 1.73102)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A80F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.782 22.0077) rotate(-92.9038) scale(4.31804 17.7684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601914,
    stopColor: "#2A80F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17 19.8309) scale(5.92629 6.45766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399715,
    stopColor: "#442932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675586,
    stopColor: "#6A5662"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0717 12.0942) rotate(122.392) scale(3.48572 6.03136)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633527,
    stopColor: "#CA7A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.9805 13.2129) rotate(-91.5327) scale(6.5392 9.16661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#482641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#483637"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6889 12.0893) rotate(122.392) scale(3.48572 6.03136)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633527,
    stopColor: "#CA7A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_713_9065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8027 13.2129) rotate(-91.5327) scale(6.5392 9.16661)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#482641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#483637"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyingFace);
export default __webpack_public_path__ + "static/media/PartyingFace.34a86128708d4dcf8a536209efc2230e.svg";
export { ForwardRef as ReactComponent };